import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import type { ReactElement } from 'react'
import React, { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import ModalContext from 'contexts/ModalContext'
import LandingPageLoyaltyTourExpCreditBenefitsModal from './LandingPageLoyaltyTourExpCreditBenefitsModal'

const image: App.Image = {
  id: '69vg83q7obl8xw4x1ac',
  title: 'Extras on your tour',
}

interface Props {
  tier: App.LoyaltyTier
  benefit: App.LoyaltyBenefit
  benefitLabel: ReactElement
}

function LandingPageLoyaltyTourExpCredit(props: Props) {
  const { tier, benefit, benefitLabel } = props
  const showModal = useContext(ModalContext)
  const intl = useIntl()

  const handleDetailsClick = useCallback(() => {
    showModal(<LandingPageLoyaltyTourExpCreditBenefitsModal
      image={image}
      benefitValue={benefit.value?.amount ?? 0}
    />)
  }, [showModal, benefit])

  return <LandingPageLoyaltyBenefitTile
    heading={intl.formatMessage({
      id: 'HsF+EPAKsy',
      defaultMessage: 'Extras on your tour',
      description: 'Heading for loyalty tour experience credit benefit tile',
    })}
    labels={<LoyaltyTierLabel kind="primary" tier={tier}>{benefitLabel}</LoyaltyTierLabel>}
    image={image}
    actions={<TextButton kind="secondary" onClick={handleDetailsClick}>
      {intl.formatMessage({
        id: 'iRametYXFh',
        defaultMessage: 'Details',
        description: 'Link to open tour experience credit benefit details modal',
      })}
    </TextButton>}
  >
    <BodyText variant="medium">
      {intl.formatMessage({
        id: 'aeU8mCpoWK',
        defaultMessage: 'Enjoy extra perks on your next adventure with a travel credit towards tour add-ons. Whether it\u2019s a sunset cruise or a food tour, these extras are on us.',
        description: 'Description of the tour experience credit loyalty benefit',
      })}
    </BodyText>
  </LandingPageLoyaltyBenefitTile>
}

export default LandingPageLoyaltyTourExpCredit
